module.exports = __webpack_public_path__ + "img/mycrypto-tokens.0862b29e.png";